import { Alg } from "cubing/alg";
import { TwistyPlayer } from "cubing/twisty";
import React, { useEffect, useRef } from "react";

export interface TwistyPlayerComponentProps {
    alg: Alg  | string;
    width: string,
    height: string
}

const TwistyPlayerComponent: React.FC<TwistyPlayerComponentProps> = ({ alg, width, height }) => {
    const containerRef = useRef<HTMLDivElement | null>(null);
  
    useEffect(() => {
      if (!containerRef.current) return;
  
      // Initialize the TwistyPlayer
      const twistyPlayer = new TwistyPlayer({ alg });
      twistyPlayer.controlPanel = "none"
      //twistyPlayer.background = "none"
      twistyPlayer.viewerLink = "none"
      twistyPlayer.style.width = width
      twistyPlayer.style.height = height
      twistyPlayer.backView = "top-right"
      //twistyPlayer.style.backgroundColor = "#ccc"
      // Append the twistyPlayer to the referenced container
      containerRef.current.appendChild(twistyPlayer);
  
      // Cleanup when component unmounts
      return () => {
        if (containerRef.current && containerRef.current.contains(twistyPlayer)) {
          containerRef.current.removeChild(twistyPlayer);
        }
      };
    }, [alg]);
  
    return <div ref={containerRef} />;
  };
  
  export default TwistyPlayerComponent;